import { createBrowserRouter } from 'react-router-dom';
import { FirmRoot, LinkProblem, NoSession, OnboardGate } from './firm/Entry';
import { FirmMessage } from './firm/Message';
import { IntakeFlow } from './intake/IntakeFlow';
import { Booking } from './intake/Booking';
import { Confirmation } from './intake/Confirmation';
import { StatusPage } from './status/StatusPage';
import { SignAgreementPage } from './agreement/SignAgreement';
import { AdminShell } from './admin/AdminShell';
import { SignInPage } from './admin/SignIn';
import { OnboardingPage } from './admin/Pipeline';
import { FirmRecordPage } from './admin/FirmRecord';
import { FirmPreviewPage } from './admin/FirmPreview';
import { SettingsPage } from './admin/Settings';
import { HomePage } from './admin/Home';
import { FeedbackQueuePage } from './admin/feedback/FeedbackQueue';
import { FeedbackDetailPage } from './admin/feedback/FeedbackDetail';
import { ReleaseDetailPage, ReleasesPage } from './admin/feedback/Releases';
import { AnnouncementsPage } from './admin/feedback/Announcements';
import { BacklogPage } from './admin/backlog/Backlog';
import { OperationsPage } from './admin/Operations';
import { BacklogItemPage } from './admin/backlog/BacklogItem';
import { MyWorkPage } from './admin/work/MyWork';
import { KpisPage } from './admin/kpi/Kpis';

export const router = createBrowserRouter([
  {
    path: '/onboard',
    element: <OnboardGate />,
    children: [
      { path: 'link', element: <LinkProblem /> },
      { path: 'status', element: <StatusPage /> },
      { path: 'agreement', element: <SignAgreementPage /> },
      { path: 'start', element: <NoSession /> },
      {
        element: <FirmRoot />,
        children: [
          { index: true, element: <IntakeFlow /> },
          { path: 'book', element: <Booking /> },
          { path: 'done', element: <Confirmation /> },
        ],
      },
    ],
  },
  { path: '/admin/sign-in', element: <SignInPage /> },
  {
    path: '/admin',
    element: <AdminShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'home', element: <HomePage /> },
      { path: 'work', element: <MyWorkPage /> },
      { path: 'onboarding', element: <OnboardingPage /> },
      { path: 'onboarding/:id', element: <FirmRecordPage /> },
      { path: 'onboarding/:id/preview', element: <FirmPreviewPage /> },
      { path: 'feedback', element: <FeedbackQueuePage /> },
      { path: 'feedback/:id', element: <FeedbackDetailPage /> },
      { path: 'backlog', element: <BacklogPage /> },
      { path: 'backlog/:id', element: <BacklogItemPage /> },
      { path: 'releases', element: <ReleasesPage /> },
      { path: 'releases/:id', element: <ReleaseDetailPage /> },
      { path: 'announcements', element: <AnnouncementsPage /> },
      { path: 'kpis', element: <KpisPage /> },
      { path: 'operations', element: <OperationsPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
  { path: '/', element: <NoSession /> },
  {
    path: '*',
    element: <FirmMessage title="Page not found"><p className="m-0">Check the address, or open the link from your invitation email.</p></FirmMessage>,
  },
]);
